import React, { useEffect, useState } from "react";
import { Select } from "antd";

import "../../app/App.css";
import useRecorder from "../../hooks/useRecorder";
import DeleteIcn from "../../assets/img/delete_icn.svg";
import {
  HeaderStyled,
  HeaderText,
  BackBtn,
  InputContainer,
  TitleContainer,
  InputStyled,
  TextAreaStyled,
  VoiceInputStyled,
  VoiceIcon,
  AudioPlayer,
  AudioPlayerContainer,
  DeleteBtn,
  SendBtn,
  SelectContainer,
} from "./newTicket.styles";
import socket from "../../assets/socketConnection";
import { socketServer } from "../../assets/socketConnection";
import BackIcon from "../../assets/img/backIcon";
import VoiceIcn from "../../assets/img/icn-mic.png";
import CircleIcn from "../../assets/img/icn-circle.png";
const NewTicket = ({ setShowTickets }) => {
  const { Option } = Select;
  let [audioURL, audioFile, isRecording, startRecording, stopRecording] =
    useRecorder();
  const [done, setDone] = useState(false);
  const [newTicket, setNewTicket] = useState({
    title: "",
    content: "",
    category: "",
    voice: "",
  });
  const Timer = () => {
    startRecording();
    setDone(true);
  };
  const SubmitTicket = () => {
    const formData = new FormData();
    formData.append("file", audioFile);
    fetch(`${socketServer}upload/voice`, {
      method: "POST",
      body: formData,
      headers: {
        contentType: "multipart/form-data",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        setNewTicket({ ...newTicket, voice: result.voice_filename });
        console.log("barnet",result)
      });
  };
  useEffect(() => {
    if (newTicket.voice) {
      console.log(newTicket);
      socket.emit("insert_new_ticket", newTicket);
      setShowTickets(false)
    }
  }, [newTicket]);

  const handleChange = (value) => {
    setNewTicket({ ...newTicket, category: value });
  };
  return (
    <>
      <HeaderStyled>
        <HeaderText>ایجاد تیکت</HeaderText>
        <BackBtn onClick={() => setShowTickets(false)}>
          <BackIcon />
        </BackBtn>
      </HeaderStyled>
      <InputContainer>
        <TitleContainer>
          <div>عنوان</div>
          <InputStyled
            type="text"
            value={newTicket.title}
            onChange={(e) =>
              setNewTicket({ ...newTicket, title: e.target.value })
            }
          />
        </TitleContainer>
        <SelectContainer>
          <Select
            defaultValue="دسته بندی"
            onChange={handleChange}
            size="default"
          >
            <Option value="فنی">فنی</Option>
            <Option value="مالی">مالی</Option>
            <Option value="احراز هویت">احراز هویت</Option>
            <Option value="سوال">سوال</Option>
          </Select>
        </SelectContainer>
        <TitleContainer>
          <TextAreaStyled
            type="text"
            placeholder="متن پیام"
            value={newTicket.content}
            onChange={(e) =>
              setNewTicket({ ...newTicket, content: e.target.value })
            }
          />
        </TitleContainer>
        <TitleContainer>
          <VoiceInputStyled>
            {isRecording ? (
              <>
                <VoiceIcon className="ml-2" onClick={stopRecording}>
                  <img src={CircleIcn} className="blink_me" alt="icon" />
                </VoiceIcon>
              </>
            ) : (
              <>
                {done ? (
                  <AudioPlayerContainer>
                    <AudioPlayer src={audioURL} controls />
                    <DeleteBtn onClick={() => setDone(false)}>
                      <img src={DeleteIcn} alt="d-icn" />
                    </DeleteBtn>
                    <SendBtn onClick={SubmitTicket}>ارسال</SendBtn>
                  </AudioPlayerContainer>
                ) : (
                  <>
                    <VoiceIcon className="ml-2" onClick={Timer}>
                      <img src={VoiceIcn} alt="icon" />
                    </VoiceIcon>
                    <span>برای ارسال پیام صوتی آیکون را لمس کنید.</span>
                  </>
                )}
              </>
            )}
          </VoiceInputStyled>
        </TitleContainer>
      </InputContainer>
    </>
  );
};

export default NewTicket;

// const [banner] = document.getElementById('banner').files;
//         const formData = new FormData();
//         formData.append('banner', banner);
//         $.ajax({
//             url: "/admins/api/categories/create_new_category",
//             type: 'POST',
//             data: formData,
//             cache: false,
//             enctype: 'multipart/form-data',
//             contentType: false,
//             processData: false,
//         }).done(data => {
//             console.log(data);
//             $('.input_img').val('').trigger("change");
//             $('.category_name').val('');
//             location.reload();
//         })
